import React from 'react';
const Login = React.lazy(() => import('./components/auth/login/Login'));
const Dashboard = React.lazy(() => import('./components/dashboard/Dahboard'));
export const protectTedRoute = [
  {
    path: '/',
    exact: true,
    component: <div></div>,
  },
  {
    component: <div></div>,
  },
];
export const routes = [
  {
    path: '/login',
    component: Login,
  },
];
